import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetPrestacionModalidadCiclicaByUser = {
  status: number | null;
  statusText: string | null;
};

const useGetPrestacionModalidadCiclicaByUser = () => {
  const [loadingGetPrestacionModalidadCiclicaByUser, setLoadingGetPrestacionModalidadCiclicaByUser] = useState(false);
  const [successGetPrestacionModalidadCiclicaByUser, setSuccessGetPrestacionModalidadCiclicaByUser] = useState(false);
  const [errorGetPrestacionModalidadCiclicaByUser, setErrorGetPrestacionModalidadCiclicaByUser] = useState<any>(null);
  const [dataGetPrestacionModalidadCiclicaByUser, setDataPrestacionModalidadCiclicaByUser] = useState<any>(null);

  const [statusGetPrestacionModalidadCiclicaByUser, setStatusGetPrestacionModalidadCiclicaByUser] =
    useState<StatusGetPrestacionModalidadCiclicaByUser>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getPrestacionModalidadCiclicaByUser = async (
    userId: string, expedienteId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetPrestacionModalidadCiclicaByUser(true);
    setSuccessGetPrestacionModalidadCiclicaByUser(false);
    setErrorGetPrestacionModalidadCiclicaByUser(null);

    try {
      const res = await apirecord.getSolicitudModalidadCiclicaByUser(userId, expedienteId);

      setStatusGetPrestacionModalidadCiclicaByUser({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetPrestacionModalidadCiclicaByUser(true);
      setDataPrestacionModalidadCiclicaByUser(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetPrestacionModalidadCiclicaByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetPrestacionModalidadCiclicaByUser(err);
      console.error("Error en getPrestacionModalidadCiclicaByUser:", err);

      throw err;

    } finally {
      setLoadingGetPrestacionModalidadCiclicaByUser(false);
    }
  };

  return {
    getPrestacionModalidadCiclicaByUser,
    loadingGetPrestacionModalidadCiclicaByUser,
    successGetPrestacionModalidadCiclicaByUser,
    errorGetPrestacionModalidadCiclicaByUser,
    dataGetPrestacionModalidadCiclicaByUser,
    statusGetPrestacionModalidadCiclicaByUser
  };
};

export default useGetPrestacionModalidadCiclicaByUser;
